import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventAttendeeQuestion } from '@models/event-attendance/event-attendee-question.model';
import { EventAttendeeTicket } from '@models/events/event-attendee-ticket.model';
import { Event } from '@models/events/event.model';
import { User } from '@models/users/user.model';
import { EventPaymentComponent } from '@modules/events/components/event-payment/event-payment.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ScreenWidthService } from '@services/shared/screen-width.service';

@Component({
  selector: 'app-claim-event-ticket',
  standalone: true,
  imports: [CommonModule, TranslateModule, EventPaymentComponent],
  providers: [ScreenWidthService, TranslateService],
  templateUrl: './claim-event-ticket.dialog.html',
  styleUrl: './claim-event-ticket.dialog.scss',
})
export class ClaimEventTicketDialog {
  ticket?: EventAttendeeTicket;
  event?: Event;
  mainImage?: string;
  loggedUser?: User;

  isDesktop = true;
  expanded = false;
  currentLang?: string;
  isAssignToMe: boolean = false;

  @ViewChild(EventPaymentComponent)
  eventPaymentComponent?: EventPaymentComponent;

  constructor(
    public dialogRef: MatDialogRef<ClaimEventTicketDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private screenWidthService: ScreenWidthService,
    private translateService: TranslateService,
  ) {
    this.screenWidthService
      .isDesktop()
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (isDesktop: boolean) => {
          this.isDesktop = isDesktop;
        },
      });

    this.translateService.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.currentLang = this.translateService.currentLang;
      });
    this.currentLang = this.translateService.currentLang;

    if (data) {
      this.ticket = data.ticket;
      this.event = data.event;
      this.mainImage = data.mainImage;
      this.loggedUser = data.loggedUser;
      this.isAssignToMe = data.isAssignToMe;
    }
  }

  close() {
    this.dialogRef.close();
  }

  claimTicket() {
    if (!this.event || !this.eventPaymentComponent) {
      return;
    }

    this.eventPaymentComponent.claimTicket();
  }

  claimTicketSuccess(ticket: EventAttendeeTicket) {
    this.dialogRef.close({ ticket });
  }

  get isStepValid(): boolean {
    return (
      !!this.eventPaymentComponent &&
      this.eventPaymentComponent.isClaimDataValid &&
      this.eventPaymentComponent.acceptTermsAndConditions &&
      this.eventPaymentComponent.acceptDataPrivacy
    );
  }

  get inProgress(): boolean {
    return (
      !!this.eventPaymentComponent &&
      this.eventPaymentComponent.isClaimInProgress
    );
  }
}
